import $ from 'jquery';
window.$ = window.jQuery = $;

import 'slick-carousel';
$('.about-team__slick').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	dots: false,
	infinite: true,
	speed: 1000,
	fade: true,
	autoplay: false,
	adaptiveHeight: true,
	autoplaySpeed: 2000,
});
$('.about-team .arrow.arrow--prew').on("click", function (event) {
	$(this).parents('.about-team').find('.about-team__slick').slick('slickPrev');
});
$('.about-team .arrow.arrow--next').on("click", function (event) {
	$(this).parents('.about-team').find('.about-team__slick').slick('slickNext');
});


